import backPNG from '~/assets/images/anatomyV2/body-part-back.png'
import backWEBP from '~/assets/images/anatomyV2/body-part-back.webp'
import feetPNG from '~/assets/images/anatomyV2/body-part-feet.png'
import feetWEBP from '~/assets/images/anatomyV2/body-part-feet.webp'
import glutesPNG from '~/assets/images/anatomyV2/body-part-glutes.png'
import glutesWEBP from '~/assets/images/anatomyV2/body-part-glutes.webp'
import heartPNG from '~/assets/images/anatomyV2/body-part-heart.png'
import heartWEBP from '~/assets/images/anatomyV2/body-part-heart.webp'
import hipPNG from '~/assets/images/anatomyV2/body-part-hip.png'
import hipWEBP from '~/assets/images/anatomyV2/body-part-hip.webp'
import jawPNG from '~/assets/images/anatomyV2/body-part-jaw.png'
import jawWEBP from '~/assets/images/anatomyV2/body-part-jaw.webp'
import kidneysPNG from '~/assets/images/anatomyV2/body-part-kidneys.png'
import kidneysWEBP from '~/assets/images/anatomyV2/body-part-kidneys.webp'
import shouldersPNG from '~/assets/images/anatomyV2/body-part-shoulders.png'
import shouldersWEBP from '~/assets/images/anatomyV2/body-part-shoulders.webp'
import stomachPNG from '~/assets/images/anatomyV2/body-part-stomach.png'
import stomachWEBP from '~/assets/images/anatomyV2/body-part-stomach.webp'

export const BODY_PARTS_QUESTION =
  'What parts of your body are you most curious about?'
export const SECTION_NUMBER = 1

export const BODY_PARTS_OPTIONS = [
  {
    key: 'heart',
    i18nKey: 'onboarding.bodyParts.options.heart',
    png: heartPNG,
    webp: heartWEBP,
  },
  {
    key: 'glutes',
    i18nKey: 'onboarding.bodyParts.options.glutes',
    png: glutesPNG,
    webp: glutesWEBP,
  },
  {
    key: 'hip',
    i18nKey: 'onboarding.bodyParts.options.hip',
    png: hipPNG,
    webp: hipWEBP,
  },
  {
    key: 'jaw',
    i18nKey: 'onboarding.bodyParts.options.jaw',
    png: jawPNG,
    webp: jawWEBP,
  },
  {
    key: 'back',
    i18nKey: 'onboarding.bodyParts.options.back',
    png: backPNG,
    webp: backWEBP,
  },
  {
    key: 'shoulders',
    i18nKey: 'onboarding.bodyParts.options.shoulders',
    png: shouldersPNG,
    webp: shouldersWEBP,
  },
  {
    key: 'stomach',
    i18nKey: 'onboarding.bodyParts.options.stomach',
    png: stomachPNG,
    webp: stomachWEBP,
  },
  {
    key: 'kidneys',
    i18nKey: 'onboarding.bodyParts.options.kidneys',
    png: kidneysPNG,
    webp: kidneysWEBP,
  },
  {
    key: 'feet',
    i18nKey: 'onboarding.bodyParts.options.feet',
    png: feetPNG,
    webp: feetWEBP,
  },
] as const
